import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Address = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Address({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.5 5.76449C10.7051 5.76449 9.25 7.22559 9.25 9.02795C9.25 10.8303 10.7051 12.2914 12.5 12.2914C14.2949 12.2914 15.75 10.8303 15.75 9.02795C15.75 7.22559 14.2949 5.76449 12.5 5.76449ZM10.75 9.02795C10.75 8.05745 11.5335 7.27071 12.5 7.27071C13.4665 7.27071 14.25 8.05745 14.25 9.02795C14.25 9.99845 13.4665 10.7852 12.5 10.7852C11.5335 10.7852 10.75 9.99845 10.75 9.02795Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.3355 22.1632C12.4149 22.2789 12.5851 22.2789 12.6645 22.1632C13.1393 21.4713 13.6106 20.7778 14.0665 20.073C14.6335 19.1964 15.3906 17.9909 16.1487 16.6785C16.9055 15.3685 17.6708 13.9393 18.2492 12.6174C18.814 11.3265 19.25 10.0309 19.25 9.02795C19.25 5.30007 16.4295 2.25 12.5 2.25C8.57054 2.25 5.75 5.30007 5.75 9.02795C5.75 10.0309 6.18603 11.3265 6.75085 12.6174C7.3292 13.9393 8.0945 15.3685 8.85125 16.6785C9.60943 17.9909 10.3665 19.1964 10.9335 20.073C11.3894 20.7778 11.8607 21.4713 12.3355 22.1632ZM7.25 9.02795C7.25 6.10097 9.42946 3.75621 12.5 3.75621C15.5705 3.75621 17.75 6.10097 17.75 9.02795C17.75 9.68876 17.436 10.7312 16.8758 12.0116C16.3292 13.261 15.5945 14.6361 14.8513 15.9227C14.0445 17.3191 13.2359 18.597 12.6665 19.4715C12.5879 19.5922 12.4121 19.5922 12.3335 19.4715C11.7641 18.597 10.9555 17.3191 10.1487 15.9227C9.4055 14.6361 8.6708 13.261 8.12415 12.0116C7.56397 10.7312 7.25 9.68876 7.25 9.02795Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'address-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Address;
